import { VocabularyBundle } from '@/types/vocabulary-management/VocabularyBundle';
import {
  Button,
  Chip,
  ContentBlock,
  Grid,
  Icon,
  Paper,
  Typography,
} from '@prometheus/components';
import { SecondaryContentWrapper } from '@prometheus/features';
import { DateFormat, formatDate } from '@prometheus/utils';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { VocabularyList } from '../VocabularyList/VocabularyList';

export interface DownloadedBundlePreviewModalProps {
  onClose?: () => void;
  bundle: VocabularyBundle;
}
export const DownloadedBundlePreviewModal: FC<DownloadedBundlePreviewModalProps> =
  ({ onClose, bundle }) => {
    const { t } = useTranslation();
    return (
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ borderRadius: 0, px: 2, py: 1 }}>
            <Grid container alignItems="center">
              <Grid item flexGrow={1} alignItems="center">
                <Grid item xs={12} mb={0.5}>
                  <Typography variant="h2" display="inline-block">
                    {bundle.name}
                  </Typography>
                  {bundle.releaseVersion && (
                    <Chip
                      size="small"
                      label={bundle.releaseVersion}
                      sx={{
                        borderRadius: 0.5,
                        color: 'textColor.header',
                        fontSize: 12,
                        ml: 1,
                        height: 22,
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textColor.label">
                    {formatDate(bundle.lastUpdated, DateFormat.DATE_TIME, true)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                {bundle.id ? (
                  <Button
                    color="info"
                    variant="contained"
                    startIcon={
                      <Icon iconName="download" sx={{ fontSize: 16 }} />
                    }
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation();
                      window.location.href = `/api/downloaded-vocabulary-bundles/${bundle.id}/download`;
                    }}
                  >
                    {t('buttons.download')}
                  </Button>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <SecondaryContentWrapper>
          <ContentBlock>
            <Grid container>
              <Grid item xs={12}>
                <VocabularyList data={bundle.vocabularies} />
              </Grid>
            </Grid>
          </ContentBlock>
        </SecondaryContentWrapper>
      </Grid>
    );
  };
